( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'benefits-card-scroll', COMPONENT );
} )( app );
